var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dx-data-grid',{ref:'child-grid-' + _vm.templateData.key,attrs:{"show-borders":true,"columns":_vm.childGridColumns,"data-source":_vm.dataSource,"columnChooser":{
    enabled: false,
  }},on:{"editor-preparing":_vm.onEditorPreparing,"content-ready":_vm.onContentReady,"init-new-row":_vm.onInitNewRow,"row-removed":_vm.onRowRemoved}},[_c('DxSearchPanel',{attrs:{"visible":false}}),_c('DxEditing',{attrs:{"allow-deleting":_vm.allowEdit,"allow-updating":_vm.allowEdit,"mode":"cell"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }